import { Component, ViewEncapsulation, OnInit, Input } from '@angular/core';
import { FormGroup, FormBuilder, FormArray } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';



@Component({
  selector: 'app-historique-details-formation-component',
  template: `
    <div class="modal-header" style="background-color:#0C8B3E;color:#fff;">
      <h4 class="modal-title">Détails</h4>
      <button type="button" class="close" aria-label="Close" (click)="activeModal.close('Close click')">
        <span aria-hidden="true" style="color:#fff;">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="row">
        <div class="col-sm-12">
          <div class="form-group">
          <label><b>{{ libelle }}</b></label>
          <textarea 
            class="form-control form-control-lg" rows="5"
            type="text" [(ngModel)]="formation" disabled>
          </textarea>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button 
        type="button" 
        class="btn btn-outline-dark" 
        (click)="activeModal.close('Close click')">
        Fermer
      </button>
    </div>
  `
})

export class HistoriqueDetailsFormationComponent {
  @Input() formation;
  @Input() libelle;
  constructor(public activeModal: NgbActiveModal) {
  }
}

@Component({
  selector: 'app-historique-formation',
  templateUrl: './historique-formation.component.html',
  styleUrls: ['./historique-formation.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class HistoriqueFormationComponent implements OnInit {
  @Input() FORMATION: any
  @Input() AUTRE_FORMATION: any
  public formationsForm: FormGroup;
  public autresFormationsForm: FormGroup;
  public typeVisualisation: any;
  public listFormations: any = [];
  public listAutreFormations: any = [];
  public response: any;
  public typeFiche: any;
  public entretien_id: string;
  public agent_id: string;
  public typeSauvegarde: any;
  public API_URL: any;
  public vueActive: any;
  public statut: any;
  // tslint:disable-next-line: max-line-length
  constructor(private fb: FormBuilder, private modalService: NgbModal) { }

  public showDetails = function (data, libelle) {
    const modalRef = this.modalService?.open(HistoriqueDetailsFormationComponent,
      { ariaLabelledBy: 'modal-basic-title', backdrop: 'static', keyboard: false, centered: true });
    modalRef.componentInstance.formation = data;
    modalRef.componentInstance.libelle = libelle;
  };

  public ngOnInit(): void {
    /* Get URL details */
    const url = window.location.href;
    const split_url = url.split('/');
    this.vueActive = split_url[4];
    this.entretien_id = split_url[6];
    this.agent_id = split_url[7];
    this.typeFiche = split_url[9];
    this.typeSauvegarde = split_url[11];
    this.typeVisualisation = split_url[12];
    this.statut = split_url[14];
    /* Formations Form */
    this.formationsForm = this.fb.group({
      formations: this.fb.array([]),
    });

    /* Autres Formations Form */
    this.autresFormationsForm = this.fb.group({
      autresformations: this.fb.array([]),
    });
    this.getAllFormations();
  }


  public getAllFormations(): void {
    this.listAutreFormations = this.AUTRE_FORMATION;
    this.listFormations = this.FORMATION;
  }

  public formations(): FormArray {
    return this.formationsForm.get('formations') as FormArray;
  }

  public autresformations(): FormArray {
    return this.autresFormationsForm.get('autresformations') as FormArray;
  }

}
